import { useMemo } from 'react';
import { getUniqueId } from './useUniqueId';

export function useFormControlId(id?: string): string {
  return useMemo(() => id || `form-control-${getUniqueId()}`, [id]);
}
